export function OutlineElipsisVerticalIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0131 14.0007C13.1167 14.0007 14.0115 13.106 14.0115 12.0023C14.0115 10.8986 13.1167 10.0039 12.0131 10.0039C10.9094 10.0039 10.0146 10.8986 10.0146 12.0023C10.0146 13.106 10.9094 14.0007 12.0131 14.0007Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0131 21.0007C13.1167 21.0007 14.0115 20.106 14.0115 19.0023C14.0115 17.8986 13.1167 17.0039 12.0131 17.0039C10.9094 17.0039 10.0146 17.8986 10.0146 19.0023C10.0146 20.106 10.9094 21.0007 12.0131 21.0007Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0131 6.99681C13.1167 6.99681 14.0115 6.10209 14.0115 4.9984C14.0115 3.89472 13.1167 3 12.0131 3C10.9094 3 10.0146 3.89472 10.0146 4.9984C10.0146 6.10209 10.9094 6.99681 12.0131 6.99681Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
